/** @jsx jsx */
import { jsx } from 'theme-ui';


export const Modal = ({ children, onClose}) => (
	<div
		onClick={onClose}
		sx={{
			position: 'fixed',
			zIndex: 999999,
			left: 0,
			top: 0,
			width: '100%',
			height: '100%',
			background: 'rgba(255,255,255,.9)'
		}}
	>
		<div
			onClick={onClose}
			sx={{
				variant: 'text.header',
				color: '#fff',
				fontSize: 6,
				position: 'absolute',
				top: '15px',
				right: '30px',
				cursor: 'pointer',
				zIndex: 1,
				transform: 'scaleX(1.5)'
			}}
		>
			X
		</div>
		<div
			sx={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '100%',
				//maxWidth: '1200px',
				//m: 'auto',
			}}
		>
			{children}
		</div>
	</div>
);
